import React from "react";

import { faBook } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import JumpToResultWrapper from "~/search/JumpTo/JumpToResult/JumpToResultWrapper";

import type { JumpToResultSearch_result$data as JumpToResultType } from "~/__generated__/JumpToResultSearch_result.graphql";

interface JumpToStreamResultProps {
	stream: Extract<JumpToResultType, { __typename: "NoteStream" }>;
	index?: number;
}

export default function JumpToStreamResult({ stream, index }: JumpToStreamResultProps) {
	return (
		<JumpToResultWrapper
			index={index}
			to={stream.streamUrl ?? "/"}
			icon={<FontAwesomeIcon icon={faBook} />}
			title={stream.displayName}
		/>
	);
}
